export enum DraggableOptions {
  LifeArea = 'life-area',
  Goal = 'goal',
  GoalSection = 'goal-section',
  Tag = 'tag',
  Task = 'task',
}
